/**
 * Converts a string value to a boolean.
 * @param {string | null | undefined} value - The input value to convert.
 * @param {boolean} [defaultValue=false] - The default boolean value if the input is null or undefined.
 * @returns {boolean} - Returns `true` if the value is `'true'` (case-insensitive), otherwise `false`.
 */

export const toBoolean = (value: string | null | undefined, defaultValue = false): boolean => {
  if (!value) return defaultValue
  return String(value)?.toLowerCase() === 'true'
}

/**
 * Validates if the given string is a valid hex color code (3 or 6 characters long).
 * @param {string} hex - The hex color code to validate (e.g., 'a3c', 'A3C8F9').
 * @returns {string | null} - Returns the hex code if valid, otherwise `null`.
 */
export const isValidHexCode = (hex: string) => {
  const regex = /^[A-Fa-f0-9]{3}$|^[A-Fa-f0-9]{6}$/
  return regex.test(hex) ? hex : null
}
